export const kycState: { [key: string]: any } = {
    identificationProvider: '',
    state: '',
    date: '',
};
